import React from "react";
import MultiSelectRefinementList from "components/search/base/MultiSelectRefinementList";

const AuthorNationalityMultiSelect = ({ countries }) => {
  return (
    <MultiSelectRefinementList
      attribute="authorNationality"
      categories={countries}
      className="refinement-list__author-nationality"
      id="refinement-list__author-nationality"
      limit={100}
      name="refinement-list__author-nationality"
      title="Nationality"
    />
  );
};

export default AuthorNationalityMultiSelect;
